import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import Logo from './../assets/img/logo.svg';


function UserSideNavbar(props) {
    const { t } = useTranslation();

    const handleLangChange = () => {
        props.onChangeHandleMenu();
    }


    return (
        <>
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
                <div className="app-brand demo mt-3 mb-3">
                    <Link to="/dashboard" className="app-brand-link">
                        <img src={Logo} alt='Cheque Print' style={{"width" : '100%'}} /> 
                    </Link>

                    <Link onClick={handleLangChange} to="#"
                        className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i className="bx bx-chevron-left bx-sm align-middle"></i>
                    </Link>
                </div>

                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1 overflow-auto">
                    <li className="menu-item">
                        <NavLink exact="true" to="/dashboard" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle"></i>
                            <div data-i18n="Email">{t('sideMenu.dashboards')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/cheque-issued" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-edit-alt"></i>
                            <div data-i18n="Email">{t('sideMenu.issuedList')}</div>
                        </NavLink>
                    </li>
                    {/* <li className="menu-item">
                        <NavLink exact="true" to="/report" className="menu-link">
                            <i className="menu-icon tf-icons bx bxs-report"></i>
                            <div data-i18n="Email">{t('sideMenu.report')}</div>
                        </NavLink>
                    </li> */}
                   

                    <li className="menu-item">
                        <NavLink exact="true" to="/invoices" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-rupee"></i>
                            <div>{t('sideMenu.invoices')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/setting"  className="menu-link">
                            <i className="menu-icon tf-icons bx bx-cog"></i>
                            <div data-i18n="Email">{t('sideMenu.settings')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/profile" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-user"></i>
                            <div data-i18n="Email">{t('sideMenu.myProfile')}</div>
                        </NavLink>
                    </li>
                   
                    <li className="menu-item">
                        <NavLink exact="true" to="/support" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-message"></i>
                            <div>{t('sideMenu.support')}</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <a exact="true" href="https://www.youtube.com/watch?v=2MfbppJNfqk" target="_blank" className="menu-link">
                            <i className="menu-icon tf-icons fa fa-youtube-play"></i>
                            <div>{t('sideMenu.demoVideo')}</div>
                        </a>
                    </li>
                </ul>
                <span className='web-v'>V {localStorage.getItem("app_version") || '0.0.0'}</span>
            </aside>
        </>
    );
}

export default UserSideNavbar;